import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { formatArrayToString } from '../utils';
import {
  ExemptCustomerQueryParams,
  SalesTaxCustomerListResponse,
} from './types';

export function getAllCustomers({
  cursor = null,
  limit = 10,
  filters,
  extend = [],
  name,
}: ExemptCustomerQueryParams) {
  const query = new URLSearchParams();

  query.append('limit', limit.toString());

  if (filters.corporationId) {
    query.append('corporation_id', filters.corporationId.toString());
  }

  if (cursor) {
    query.append('cursor', cursor);
  }

  if (name) {
    query.append('name', name);
  }

  if (filters.certificateTypes) {
    const certificateTypesFilter = formatArrayToString(
      filters.certificateTypes
    );
    query.append('certificate_types', certificateTypesFilter);
  }

  if (filters.exemptionJurisdiction) {
    const exemptionJurisdictionFilter = formatArrayToString(
      filters.exemptionJurisdiction
    );
    query.append('exemption_jurisdiction', exemptionJurisdictionFilter);
  }

  if (filters.exemptionStatus) {
    query.append('exemption_status', filters.exemptionStatus);
  }

  if (filters.expirationStatus) {
    query.append('expiration_status', filters.expirationStatus);
  }

  if (filters.hasExemption) {
    query.append('has_exemption', filters.hasExemption.toString());
  }

  if (extend.length > 0) {
    const extendFilter = formatArrayToString(extend);
    query.append('extend', extendFilter);
  }

  const { data, error, isLoading, mutate } =
    useSWR<SalesTaxCustomerListResponse>(
      `new-sales-tax/customers?${query}`,
      SWRFetcher(
        {
          method: 'GET',
        },
        undefined
      )
    );

  return {
    customers: data?.data.customers ?? [],
    cursor: data?.data.cursor,
    totalCustomers: data?.data.total_customers ?? 0,
    isLoading,
    error,
    mutate,
  };
}
